<template>
<div class="overlay absolute top-0 left-0 w-full h-full bg-[#f6f5ff00]/90 dark:bg-black/30 flex justify-center items-center backdrop-blur backdrop-opacity-15" 
    @click="captureEvent" @scroll.prevent="captureEvent" @wheel.prevent="captureEvent">
    <div class="hidden-dialog">
        <div v-if="!showPaySuccessView && !showBalanceCheckout"
            class="payment-panel bg-[#f5fafa] max-w-[1000px] mx-auto rounded-[20px] shadow-2xl">
            <div
                class="payment-form-block-header flex flex-col items-center  min-h-[180px] px-[15px] mx-auto mt-[80px] text-center">
                <div class="w-full relative min-h-[1px] px-[15px]">
                    <h1 class="payment-title text-[#007a7a] leading-none mt-[86px] mb-[26px] font-bold text-[40px]">
                        <img src="@/assets/index/img/pay/lock.png"
                            class="inline-block align-bottom mr-[8px]">
                            {{ $t("cpts.payment_view.title") }}
                    </h1>
                    <p class="payment-intro text-[#66afaf] m-0 text-[20px]">{{ $t("cpts.payment_view.intro") }}</p>
                </div>
            </div>
            <!--global errors message-->
            <div class="w-full text-center">
                <div class="error-message multiple global-errors">
                    {{ globalMessage }}
                </div>
            </div>
            <!--container-->
            <div class="flex justify-between w-full max-w-[1400px] px-[15px] pt-[50px] mx-auto min-h-[1px]">
                <!--payment-form-block-payment-item-description-->
                <div class="w-1/2 ml-[40px] px-[15px] min-h-[1px]">
                    <!-- <h3
                        class="text-[#007a7a] px-0 pt-0 py-[0.3em] mb-[1.5em] border-b border-b-[#e0e0e0] font-400 text-[24px] leading-normal">
                        Item Description</h3> -->
                    <div
                        class="payment-form-block-item payment-product-card w-full max-w-[400px] bg-[#007a7a] rounded-[4px] pt-[51px] pb-[57px] mt-0 mx-auto mb-[30px] text-white text-center">
                        <h4 class="text-white py-0 px-[12px] text-[20px] mb-[0.5em] leading-[1.6] font-bold">{{ display_title }}</h4>
                        <p class="text-[#66afaf] font-semibold leading-[1.7] mb-[1em] text-[14px]">{{ description }}</p>
                        <div v-if="original_price !== null" class="payment-original-price">
                        <del>{{ display_currency }}{{ formatPaymentAmount(original_price) }}<span v-if="type == '1'"> / {{ display_unit }}</span></del>
                    </div>
                    <div class="flex justify-center items-baseline text-center text-white">
                            <sup
                                class="relatvie inline-block -top-[2em] font-semibold text-[20px] align-baseline leading-none">{{ display_currency }}</sup>
                            <span class="inline-block mt-[18px] text-[80px] text-center font-normal">{{ formatPaymentAmount(display_price) }}</span>
                            <sub v-if="type == '1'" class="inline-block bottom-0 font-simibold text-[20px] align-baseline leading-none">/
                                {{ display_unit }}</sub>
                        </div>
                        <div v-if="promotionVisible" class="payment-promo-card mx-auto mt-[24px]">
                            <div class="flex items-center justify-between gap-[12px]">
                            <div>
                                <div class="text-[14px] font-bold text-[#8b4210] text-left">{{ $t('activity.summer.payment_title') }}</div>
                                <div class="mt-[4px] text-[12px] leading-[18px] text-[#5f7472]">
                                    {{ promotionDiscount > 0 ? promotionAppliedText : promotionPendingText }}
                                </div>
                            </div>
                            <div v-if="promotionDiscount > 0" class="shrink-0 rounded-full bg-[#ff8a3d] px-[10px] py-[5px] text-[12px] font-bold text-white">
                                -${{ formatPaymentAmount(promotionDiscount) }}
                            </div>
                            </div>
                        </div>
                    </div>
                    <a class="payment-change-link inline-block box-border cursor-pointer py-[13px] px-[34px] float-left ml-[13px] mt-[10px] mb-[30px] text-center text-[#007a7a] text-[16px] font-600 rounded-[4px] bg-transparent border border-[#007a7a] hover:bg-[#007a7a] hover:text-white"
                        :href="changePlanUrl" @click.prevent="handleChangePlan">{{ $t("cpts.payment_view.change") }}</a>
                </div>
                <!--ayment-form-block-payment-details-->
                <div class="w-1/2 ml-[50px]">
                    <!-- <h3
                        class="text-[#007a7a] px-0 pt-0 py-[0.3em] mb-[1.5em] border-b border-b-[#e0e0e0] font-400 text-[24px] leading-normal">
                        <span>Payment</span>
                    </h3> -->
                    <div class="relative w-full px-[15px] mx-auto min-h-[1px]">
                        <!-- warning-message -->
                        <div v-if="errorMessage != ''"
                            class="inline-block max-w-[434px] bg-[#fcf2e6] text-[#df7b00] text-center rounded-[4px]">
                            <!--message item-->
                            <span class="inline-block font-semibold my-[8px] mx-[16px] text-[#df7b00] leading-[1.14]">
                                <i class="relative inline-flex align-middle mr-[8px] top-[-1px] text-[#df7b00]">
                                    <span class="inline-flex font-semibold"
                                        js-class="filled direction-right direction-left direction-up direction-bottom error-color main-color second-color any-color">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 9.77778V12.7407M12 15.7037H12.0075M10.527 4.85092L3.23087 17.3485C3.08044 17.6158 3.00085 17.9188 3.00001 18.2275C2.99916 18.5361 3.0771 18.8396 3.22607 19.1078C3.37504 19.3759 3.58984 19.5994 3.84911 19.7559C4.10838 19.9125 4.40308 19.9966 4.70388 20H19.2961C19.5969 19.9966 19.8916 19.9125 20.1509 19.7559C20.4102 19.5994 20.625 19.3759 20.7739 19.1078C20.9229 18.8396 21.0008 18.5361 21 18.2275C20.9992 17.9188 20.9196 17.6158 20.7691 17.3485L13.473 4.85092C13.3194 4.59116 13.1032 4.3764 12.8452 4.22735C12.5872 4.0783 12.2961 4 12 4C11.7039 4 11.4128 4.0783 11.1548 4.22735C10.8968 4.3764 10.6806 4.59116 10.527 4.85092Z"
                                                stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                    {{ errorMessage }}
                                </i>
                            </span>
                        </div>

                        <div class="flex items-center w-full max-w-[400px] min-h-[340px]">
                            <!--payment-form-block-payment-tabs-->
                            <div class="w-full">
                            <div v-if="!recharge" class="payment-coupon-box w-full max-w-[534px] mb-[18px]">
                                <el-input
                                    v-model="paymentCouponCode"
                                    :placeholder="$t('cpts.checkout.couponPlaceholder')"
                                    clearable
                                    @input="clearPaymentCouponMessages"
                                >
                                    <template #append>
                                        <el-button @click="applyPaymentCoupon">{{ $t('cpts.checkout.applyCoupon') }}</el-button>
                                    </template>
                                </el-input>
                                <div v-if="paymentCouponError" class="payment-coupon-message is-error">{{ paymentCouponError }}</div>
                                <div v-if="paymentCouponSuccess" class="payment-coupon-message is-success">{{ paymentCouponSuccess }}</div>
                            </div>
                            <div class="flex justify-center items-stretch text-center m-auto rounded-[4px] max-w-[534px] w-[100%] h-[110px]">
                                <div v-if="!recharge && display_price > 0" class="payment-method-tab relative rounded-l-[4px] w-[33%] mr-[-1px] h-[108px] bg-white text-center cursor-pointer border border-[#66afaf] font-medium"
                                    :class="{'is-selected': pay_type == '3' }" @click="payWithBalance">
                                    <img class="object-contain w-[85px] h-[20px] mx-auto mt-[25px] mb-[14px] align-middle border-none box-border text-center overflow-clip"
                                        src="@/assets/index/img/pay/icon_balance_title.png">
                                    <span class="mx-auto text-[#007a7a] font-600 clear-right">{{ $t("cpts.payment_view.payment.balance") }}</span>
                                </div>
                                <div v-if="display_price > 0" class="payment-method-tab relative w-[33%] mr-[-1px] h-[108px] bg-white text-center cursor-pointer border border-[#66afaf] font-medium"
                                    :class="{'is-selected': pay_type == '1', 'rounded-l-[4px] !w-[50%]': recharge}" @click="payWithCreditCard">
                                    <img class="object-contain w-[85px] h-[20px] mx-auto mt-[25px] mb-[14px] align-middle border-none box-border overflow-clip text-center overflow-clip"
                                        src="@/assets/index/img/pay/credit-cards.png">
                                    <span class="mx-auto text-[#007a7a] font-600 clear-right">{{ $t("cpts.payment_view.payment.credit_card") }}</span>
                                </div>
                                <div v-if="display_price > 0" class="payment-method-tab rounded-r-[4px] w-[33%] h-[108px] bg-white text-center cursor-pointer border border-[#66afaf] font-medium"
                                    :class="{'is-selected': pay_type == '2', '!w-[50%]': recharge}" @click="payWithAlipay">
                                    <img class="object-contain w-[85px] h-[20px] mx-auto mt-[25px] mb-[14px] align-middle border-none box-border text-center overflow-clip"
                                        src="@/assets/index/img/pay/icon_alipay_title.png">
                                    <span class="mx-auto text-[#007a7a] font-600 clear-right">{{ $t("cpts.payment_view.payment.alipay") }}</span>
                                </div>

                                <a v-if="display_price == 0" class="inline-block box-border cursor-pointer w-full h-[108px] py-[13px] px-[34px] float-left ml-[13px] mt-[10px] mb-[30px] flex justify-center items-center text-[#007a7a] text-[16px] font-600 rounded-[4px] bg-transparent border border-[#007a7a] hover:bg-[#007a7a] hover:text-white"
                                    :href="changePlanUrl" @click.prevent="payWithBalance">{{ $t("cpts.payment_view.payment.free") }}</a>
                            </div>
                            </div>
                        </div>

                        <div class="hidden flex justify-between items-center py-[24px] max-w-[400px] border-t border-t-[#e0e0e0]">
                            <label class="m-0 w-auto font-semibold text-[16px]">{{ $t("cpts.payment_view.total") }}</label><label
                                class="m-0 w-auto font-semibold text-[16px]">{{ pay_total }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PaySuccessView v-if="showPaySuccessView" :order_no="this.order_info.order_no"></PaySuccessView>
        <BalanceCheckoutView 
            v-if="showBalanceCheckout" 
            :order_no="order_info.order_no"
            :subtotal="order_info.total_price"
            :title="order_info.title"
            :coupon-locked="couponLocked"
            :promotion-discount="promotionDiscount"
            @close="showBalanceCheckout = false"
            @success="handleBalancePaySuccess"
        ></BalanceCheckoutView>
    </div>
</div>
</template>

<script>
import { formatPaymentAmount } from '@/util/payment-amount';
import { prepareOrder, prepareRenewOrder, createOrder, renewOrder, getOrderInfo, stripePay, applyCoupon } from '@/http/api/order'
import { stripeRecharge } from '@/http/api/member'
import PaySuccessView from './pay-success-view.vue'
import BalanceCheckoutView from './balance-checkout-view.vue'
import { isPromotionEligibleType, promotionConfig, promotionText } from '@/config/site-theme'
import { createRequestKey } from '@/util/request-key'

export default {
    name: 'PaymentView',
    components: { PaySuccessView, BalanceCheckoutView },
    data() {
        return {
            type: '1',
            recharge: false,
            renew: false,
            pay_type: 2,
            source: '', // form '/staticisp', '/ucenter/staticisp'
            
            recharge_params: {
                deposit: 0,
                currency: 'usd',
            },

            residential_order_params: {
                title: '', money: 0, package_id: '', days: ''
            },
            staticisp_order_params: {
                order_no: '', money: 0, amount: '', location: '', static_commodity: '', date_unit: ''
            },

            renew_order_params: {
                renew_ip_ids: '', num: '', date_unit: ''
            },
            pre_order_detail: null,
            order_request_key: '',
        
            order_info: {order_no: '', title: null, total_price: null, flow: null, days: null, coupon: '', discount_price: 0},
            pay_info: {currency: 'usd', amount: 0},


            showPaySuccessView: false,
            showBalanceCheckout: false,
            globalMessage: '',
            errorMessage: '',
            paymentCouponCode: '',
            paymentCouponDiscount: 0,
            paymentCouponError: '',
            paymentCouponSuccess: '',
        }
    },
    computed: {
        changePlanUrl() {
            if (this.type == '1') {
                return `/residential?package_id=${this.residential_order_params.package_id}`
            } else {
                return this.renew ? `/staticisp` : `/ucenter/staticisp/ips`
            }
        },
        display_title() {
            if (this.recharge) {
                return this.$t("cpts.payment_view.plan.recharge");
            } else if (this.type == '1') {
                return this.order_info.title ?? this.residential_order_params.title ?? ''
            } else {
                return this.$t("cpts.payment_view.plan.static_ip")
            }
        },
        description() {
            if (this.recharge) {
                return '';
            } else if (this.type == '1') {
                return this.$t("cpts.payment_view.plan.residential");
            } else {
                if (this.renew) {
                    return this.$t("cpts.payment_view.plan.renew", {num: this.renew_order_params.num});
                } else {
                    return this.$t("cpts.payment_view.plan.multi_region", {ip_amount: this.staticisp_order_params.amount, country_num: this.staticisp_order_params.location});                    
                }
            }
        },

        display_currency() {
            if (this.pay_info.currency == 'cny') {
                return '￥';
            } else {
                return '$';
            } 
        },

        original_price() {
            if (this.recharge) return null;
            const current = Number(this.display_price);
            const discount = Number(this.order_info.discount_price || 0);
            const original = this.order_info.subtotal != null
                ? Number(this.order_info.subtotal) : current + discount;
            return Number.isFinite(current) && Number.isFinite(original)
                && current >= 0 && original > current ? original : null;
        },

        display_price() {
            // 新购和续费均优先显示服务端订单应付金额，包括优惠后零元。
            if (!this.recharge && this.order_info.total_price != null) {
                return this.order_info.total_price;
            }
            // Renewal quotes use the server's exact four-decimal total. Do not
            // fall back to the original plan amount (or the stale pay_info
            // cents value), which is wrong for batch renewals.
            if (this.renew && this.pre_order_detail?.total_amount !== undefined) {
                return this.pre_order_detail.total_amount;
            }
            if (this.pay_info.amount == 0) {
                if (this.order_info.total_price) {
                    return this.order_info.total_price;
                }

                if (this.pre_order_detail && this.pre_order_detail.pay_price >= 0) {
                    return this.pre_order_detail.pay_price;
                }

                if (this.type == '1') {
                    return this.residential_order_params.money;
                } else {
                    return this.staticisp_order_params.money;
                }
            } else if (this.pay_info.currency == 'usd') {
                return  this.pay_info.amount / 100;
            } else if (this.pay_info.currency == 'cny') {
                return this.pay_info.amount / 100;
            }
        },

        display_unit() {
            return (this.order_info.days ?? this.residential_order_params.days ?? 0) + " "+ this.$t("cpts.payment_view.plan.days");
        },

        pay_total() {
            if (!this.recharge && this.order_info.total_price != null) {
                const currency = String(this.pre_order_detail?.currency || this.pay_info.currency || 'USD').toUpperCase();
                const symbol = currency === 'USD' ? '$' : currency === 'CNY' ? '￥' : `${currency} `;
                return symbol + formatPaymentAmount(this.order_info.total_price);
            }
            if (this.renew && this.pre_order_detail?.total_amount !== undefined) {
                const currency = String(this.pre_order_detail.currency || this.pay_info.currency || 'USD').toUpperCase();
                return `${currency} ${formatPaymentAmount(this.pre_order_detail.total_amount)}`;
            }
            if (this.pay_info.amount == 0) {
                return "$" + formatPaymentAmount(this.order_info.total_price ?? this.staticisp_order_params.money ?? this.residential_order_params.money);
            } else if (this.pay_info.currency == 'usd') {
                return "$" + formatPaymentAmount(this.pay_info.amount / 100);
            } else if (this.pay_info.currency == 'cny') {
                return "￥" + formatPaymentAmount(this.pay_info.amount / 100);
            } else {
                return formatPaymentAmount(this.pay_info.amount / 100) + " " + this.pay_info.currency;
            }
        },
        promotionEligible() {
            return !this.recharge && !this.renew && isPromotionEligibleType(this.type);
        },
        autoCouponCode() {
            return promotionConfig.code;
        },
        promotionAppliedText() {
            return promotionText(this, 'payment_applied');
        },
        promotionPendingText() {
            return promotionText(this, 'payment_pending');
        },
        activityCouponSelected() {
            const code = this.paymentCouponCode || this.order_info.coupon || this.pre_order_detail?.coupon || '';
            return String(code).toLowerCase() === String(promotionConfig.code || '').toLowerCase();
        },
        promotionDiscount() {
            if (this.paymentCouponDiscount > 0 && this.activityCouponSelected) {
                return Number(this.paymentCouponDiscount);
            }
            const discount = this.pre_order_detail && this.pre_order_detail.discount_price
                ? Number(this.pre_order_detail.discount_price)
                : Number(this.order_info.discount_price || 0);
            return this.activityCouponSelected && Number.isFinite(discount) ? discount : 0;
        },
        promotionVisible() {
            return this.activityCouponSelected && (this.promotionEligible || this.promotionDiscount > 0);
        },
        couponLocked() {
            return false;
        },
    },

    created() {
        const params = this.$route.query;
        this.type = params?.type;
    },
    mounted() {
        const params = this.$route.query;
        if (params?.pay_result == '2') {
            this.errorMessage = this.$t("cpts.payment_view.message.canceled");

            this.pay_success = true;
            this.pay_type = params?.pay_type ?? 2;
            this.order_info.order_no = params?.order_no ?? ''

        } else if (params?.pay_result == '1') {
            this.pay_type = params?.pay_type ?? 1;
            this.order_info.order_no = params?.order_no ?? ''
            this.showPaySuccessView = true            
        } else if (params?.order_no?.length > 0) {
            this.order_info.order_no = params?.order_no ?? ''

            this.handleGetOrderInfo();
        }
    },
    methods: {
    formatPaymentAmount,
        captureEvent(event) {
            event.stopPropagation();
            event.preventDefault();
        },
        
        updateInfo(params) {
            this.source = params?.source ?? this.source;
            this.type = params?.type ?? this.type;
            
            if (params?.deposit) {
                this.recharge = true;
                this.recharge_params = params;
                this.pay_info.amount = params.deposit * 100;
            } else {
                if (params?.renew_type === 'renew') {
                    this.renew = true;
                    this.renew_order_params = {
                        renew_ip_ids: params?.renew_ip_ids,
                        num: params?.num,
                        date_unit: params?.date_unit ?? this.$t("cpts.payment_view.plan.default_unit")
                    }
                } else {
                    if (params?.type == '1') {
                        this.residential_order_params = {
                            package_id: params?.id,
                            money: params?.salePrice,
                            title: params?.title,
                            days: params?.days
                        }
                    
                    } else if (params?.type == '2') {
                        this.staticisp_order_params = {
                            order_no: params?.order_no,
                            money: params?.money,
                            location: params?.location,
                            amount: params?.amount,
                            static_commodity: params?.static_commodity,
                            date_unit: params?.date_unit,
                        }
                    }
                }

                this.handlePrepareOrder();
            }
        },
        handleChangePlan() {
            this.$emit('close');
        },

        async handlePrepareOrder() {
            if (this.order_info.order_no === '') {
                if (this.renew) {
                    const { type, pay_type, renew_order_params } = this;
                    this.order_request_key = this.order_request_key || createRequestKey('renew');
                    await prepareRenewOrder({ type, pay_type, renew_ip_ids: renew_order_params.renew_ip_ids, date_unit: renew_order_params.date_unit, request_key: this.order_request_key}).then(res => {
                        // console.log(res)
                        this.pre_order_detail = res.data;
                    }).catch((error) => {
                        if ('data' in error && 'msg' in error.data) {
                            this.errorMessage = error?.data.msg;
                        } else {
                            this.errorMessage = error?.message;
                        }
                    })   
                } else {
                    const { type, pay_type, staticisp_order_params, residential_order_params } = this;
                    var params = {}
                    if (type == '2') {
                        params = { type, pay_type, date_unit: staticisp_order_params.date_unit, static_commodity: staticisp_order_params.static_commodity}
                    } else {
                        params = { type, pay_type, validity_days: residential_order_params.days, package_id: residential_order_params.package_id}
                    }
                    if (this.promotionEligible) {
                        params.coupon = this.autoCouponCode;
                    }
                    this.order_request_key = this.order_request_key || createRequestKey('order');
                    params.request_key = this.order_request_key;
                    await prepareOrder(params).then(async res => {
                        // console.log(res)
                        this.pre_order_detail = res.data;
                        this.initPaymentCouponFromOrder(res.data);
                        if (this.paymentCouponCode) await this.applyPaymentCoupon();
                    }).catch((error) => {
                        if ('data' in error && 'msg' in error.data) {
                            this.errorMessage = error?.data.msg;
                        } else {
                            this.errorMessage = error?.message;
                        }
                    })  
                }
            }
        },

        async handleCreateOrder() {
            // this.$modal.loading('Loading');

            if (this.order_info.order_no === '') {
                if (this.renew) {
                    const { type, pay_type, renew_order_params } = this;
                    await renewOrder({ type, pay_type, renew_ip_ids: renew_order_params.renew_ip_ids, date_unit: renew_order_params.date_unit, request_key: this.order_request_key}).then(res => {
                        const data = res.data || {};
                        this.order_info = {
                            ...this.order_info,
                            ...data,
                            order_no: data.order_no || data.orderNo || '',
                            total_price: data.total_price ?? data.amount ?? null,
                            title: data.title || this.$t('cpts.payment_view.plan.renew', {num: this.renew_order_params.num}),
                        };
                    }).catch((error) => {
                        if ('data' in error && 'msg' in error.data) {
                            this.errorMessage = error?.data.msg;
                        } else {
                            this.errorMessage = error?.message;
                        }
                    })

                } else {
                    const { type, pay_type, residential_order_params, staticisp_order_params } = this;

                    if (type == '1') {
                        const params = { type, pay_type, package_id: residential_order_params.package_id };
                        if (this.promotionEligible) {
                            params.coupon = this.autoCouponCode;
                        }
                        params.request_key = this.order_request_key || createRequestKey('order');
                        await createOrder(params)
                        .then(res => {
                            // console.log(res)
                            this.order_info = res.data;
                            this.initPaymentCouponFromOrder(res.data);
                        }).catch((error) => {
                            if ('data' in error && 'msg' in error.data) {
                                this.errorMessage = error?.data.msg;
                            } else {
                                this.errorMessage = error?.message;
                            }
                        })
                    } else {
                        const params = { type, pay_type, date_unit: staticisp_order_params.date_unit, static_commodity: staticisp_order_params.static_commodity };
                        if (this.promotionEligible) {
                            params.coupon = this.autoCouponCode;
                        }
                        params.request_key = this.order_request_key || createRequestKey('order');
                        await createOrder(params)
                            .then(res => {
                                // console.log(res)
                                this.order_info = res.data;
                                this.initPaymentCouponFromOrder(res.data);
                            }).catch((error) => {
                                if ('data' in error && 'msg' in error.data) {
                                    this.errorMessage = error?.data.msg;
                                } else {
                                    this.errorMessage = error?.message;
                                }
                            })
                    }
                }
            }
        },

        async handleGetOrderInfo() {
            // this.$modal.loading('Loading');

            if (this.order_info.order_no !== '') {
                const { order_no } = this.order_info;
                await getOrderInfo({ order_no })
                    .then(res => {
                        // console.log(res)
                        
                        this.order_info.title = res.data.title;
                        // 订单详情 total_price 为折前价，pay_price 才是实际应付。
                        this.$set(this.order_info, 'subtotal', res.data.total_price);
                        this.order_info.total_price = res.data.pay_price ?? res.data.total_price;
                        this.order_info.coupon = res.data.coupon || '';
                        this.order_info.discount_price = res.data.discount_price || 0;
                        this.initPaymentCouponFromOrder(res.data);

                        if (this.type == '1') {
                            this.order_info.flow = res.data.items[0].pak_flow_num;
                            this.order_info.days = res.data.items[0].pak_days;
                        } else {
                            // reformat order items
                            this.staticisp_order_params.location = res.data.items.length;
                            this.staticisp_order_params.amount = res.data.items.reduce((amount, item) => amount += item.quantity, 0);
                        }

                    }).catch((error) => {
                        if ('data' in error && 'msg' in error.data) {
                            this.errorMessage = error?.data.msg;
                        } else {
                            this.errorMessage = error?.message;
                        }
                    })
            }
        },

        async payWithCreditCard() {
            this.pay_type = 1
            await this.pay()
        },
        async payWithAlipay() {
            this.pay_type = 2
            await this.pay()
        },
        async payWithBalance() {
            this.pay_type = 3
            await this.pay()
        },

        async pay() {
            this.$modal.loading('Loading');
            
            if (this.recharge) {
                stripeRecharge({pay_type:this.pay_type, deposit: this.recharge_params.deposit, source: this.source}).then(res=>{
                    if (res.data.url) {
                        // 与旧版一致，取消后返回发起支付的商品页。
                        try {
                            const orderNo = this.order_info.order_no || res.data.recharge_no || res.data.order_no;
                            if (orderNo) sessionStorage.setItem(`payment-source:${orderNo}`, this.source || this.$route.path);
                        } catch (_) { /* 存储不可用不阻断支付。 */ }
                        window.location.href = res.data.url
                    }
                }).catch((error)=>{
                    if ('data' in error && 'msg' in error.data) {
                        this.errorMessage = error?.data.msg;
                    } else {
                        this.errorMessage = error?.message;
                    }
                }).finally (async () => {
                    this.$modal.closeLoading();
                });
            } else {
                if (this.order_info.order_no == '') {
                    await this.handleCreateOrder()
                } else {
                    await this.handleGetOrderInfo()
                }

                if (this.order_info.order_no == '') {
                    this.$modal.closeLoading();
                    return
                }

                if (this.paymentCouponCode || this.order_info.coupon) {
                    await this.applyPaymentCoupon();
                    if (this.paymentCouponError) {
                        this.$modal.closeLoading();
                        return;
                    }
                }

                if (this.pay_type == 3) {
                    // 使用余额支付组件
                    this.showBalanceCheckout = true;
                    this.$modal.closeLoading();
                } else {
                    stripePay({pay_type:this.pay_type, order_no: this.order_info.order_no, source: this.source, coupon: this.paymentCouponCode}).then(res=>{
                        if (res.data.url) {
                            // 与旧版一致，取消后返回发起支付的商品页。
                        try {
                            const orderNo = this.order_info.order_no || res.data.recharge_no || res.data.order_no;
                            if (orderNo) sessionStorage.setItem(`payment-source:${orderNo}`, this.source || this.$route.path);
                        } catch (_) { /* 存储不可用不阻断支付。 */ }
                        window.location.href = res.data.url
                        }
                    }).catch((error)=>{
                        if ('data' in error && 'msg' in error.data) {
                            this.errorMessage = error?.data.msg;
                        } else {
                            this.errorMessage = error?.message;
                        }
                    }).finally (async () => {
                        this.$modal.closeLoading();
                    });
                }
            }
        },
        handleBalancePaySuccess() {
            this.showBalanceCheckout = false;
            this.showPaySuccessView = true;
        },

        initPaymentCouponFromOrder(order) {
            if (!order || this.paymentCouponCode !== '') {
                return;
            }
            this.paymentCouponCode = order.coupon || (this.promotionEligible ? this.autoCouponCode : '');
            this.paymentCouponDiscount = Number(order.discount_price || 0);
        },

        clearPaymentCouponMessages() {
            this.paymentCouponError = '';
            this.paymentCouponSuccess = '';
            this.paymentCouponDiscount = 0;
            this.order_info.discount_price = 0;
        },

        async applyPaymentCoupon() {
            this.paymentCouponError = '';
            this.paymentCouponSuccess = '';
            let orderNo = this.order_info.order_no || this.pre_order_detail?.order_no;
            if (!orderNo) {
                await this.handleCreateOrder();
                orderNo = this.order_info.order_no;
            }
            if (!orderNo) return;
            try {
                const res = await applyCoupon({
                    coupon: this.paymentCouponCode,
                    order_no: orderNo,
                });
                this.paymentCouponDiscount = Number(res.data.discount || 0);
                this.order_info.discount_price = this.paymentCouponDiscount;
                this.order_info.total_price = res.data.pay_price;
                this.$set(this.order_info, 'subtotal', res.data.subtotal);
                if (this.pre_order_detail) {
                    this.$set(this.pre_order_detail, 'pay_price', res.data.pay_price);
                    // 续费卡片和支付总额均读取 total_amount，同步服务端折后金额。
                    if (this.renew) this.$set(this.pre_order_detail, 'total_amount', res.data.pay_price);
                }
                this.order_info.coupon = this.paymentCouponCode;
                this.paymentCouponSuccess = this.$t('cpts.checkout.success.couponApplied');
            } catch (error) {
                this.paymentCouponDiscount = 0;
                this.paymentCouponError = error?.response?.data?.message || error?.data?.msg || this.$t('cpts.checkout.error.invalidCoupon');
            }
        },
    }
}
</script>

<style scoped>
.payment-panel {
    background:
        radial-gradient(circle at 82% 16%, rgba(247, 201, 72, 0.16), transparent 22%),
        linear-gradient(180deg, #f7fcf8 0%, #eef8f4 100%) !important;
}

.payment-title {
    color: #173b3a !important;
}

.payment-intro {
    color: #6c7f7b !important;
}

.payment-panel .text-\[\#007a7a\],
.payment-panel .text-\[\#66afaf\] {
    color: #173b3a !important;
}

.payment-panel .border-\[\#007a7a\],
.payment-panel .border-\[\#66afaf\] {
    border-color: rgba(255, 138, 61, 0.34) !important;
}

.payment-panel .bg-\[\#007a7a\] {
    background-color: #fff4df !important;
}

.payment-product-card {
    color: #173b3a !important;
    background:
        radial-gradient(circle at 82% 16%, rgba(247, 201, 72, 0.34), transparent 22%),
        linear-gradient(145deg, #fff9ec 0%, #fff1df 48%, #eaf7f3 100%) !important;
    border: 1px solid rgba(255, 138, 61, 0.3);
    box-shadow: 0 18px 42px rgba(154, 75, 18, 0.12);
}

.payment-product-card h4,
.payment-product-card .text-white {
    color: #173b3a !important;
}

.payment-product-card p {
    color: #6c7f7b !important;
}

.payment-promo-card {
    width: calc(100% - 42px);
    border: 1px solid rgba(255, 138, 61, 0.38);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.86);
    padding: 13px 14px;
    box-shadow: 0 14px 28px rgba(255, 138, 61, 0.16);
}

.payment-method-tab {
    border-color: rgba(255, 138, 61, 0.34) !important;
    color: #173b3a !important;
}

.payment-method-tab span {
    color: #173b3a !important;
}

.payment-method-tab.is-selected {
    background: #fff4df !important;
    box-shadow: inset 0 0 0 2px rgba(255, 138, 61, 0.34);
}

.payment-coupon-box {
    border: 1px solid rgba(255, 138, 61, 0.22);
    border-radius: 14px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.86), rgba(255, 247, 231, 0.66));
    padding: 10px;
    box-shadow: 0 12px 28px rgba(255, 138, 61, 0.08);
}

.payment-coupon-box ::v-deep .el-input-group {
    height: 52px;
    overflow: hidden;
    border: 1px solid rgba(18, 110, 106, 0.18);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 8px 18px rgba(18, 110, 106, 0.06);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.payment-coupon-box ::v-deep .el-input-group:focus-within {
    border-color: rgba(255, 138, 61, 0.72);
    box-shadow: 0 0 0 4px rgba(255, 138, 61, 0.12), 0 10px 24px rgba(255, 138, 61, 0.1);
}

.payment-coupon-box ::v-deep .el-input__inner {
    height: 52px;
    line-height: 52px;
    border: 0;
    background: transparent;
    color: #173b3a;
    font-weight: 500;
    box-shadow: none;
}

.payment-coupon-box ::v-deep .el-input-group__append {
    width: 148px;
    height: 52px;
    border: 0;
    border-left: 1px solid rgba(18, 110, 106, 0.14);
    background: rgba(255, 248, 233, 0.82);
    color: #126e6a;
    padding: 0;
    text-align: center;
    vertical-align: middle;
}

.payment-coupon-box ::v-deep .el-input-group__append .el-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 12px);
    height: 40px;
    line-height: 40px;
    margin: 6px;
    padding: 0 16px;
    border: 0;
    border-radius: 10px;
    background: linear-gradient(135deg, #ff8a3d, #f7b955);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
    box-shadow: 0 8px 18px rgba(255, 138, 61, 0.22);
}

.payment-coupon-box ::v-deep .el-input-group__append .el-button:hover {
    background: linear-gradient(135deg, #ff7a22, #f4aa37);
    color: #fff;
    box-shadow: 0 10px 22px rgba(255, 122, 34, 0.28);
}

.payment-coupon-message {
    margin-top: 8px;
    font-size: 12px;
    line-height: 18px;
}

.payment-coupon-message.is-error {
    color: #df7b00;
}

.payment-coupon-message.is-success {
    color: #126e6a;
}

.payment-change-link {
    color: #ff7a22 !important;
    border-color: #ff8a3d !important;
}

.payment-change-link:hover {
    color: #fff !important;
    background: #ff8a3d !important;
}
</style>
<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
//   background-color: rgba(0, 0, 0, 0); /* 完全透明 */
  z-index: 1500; /* 确保在最前 */
}

.hidden-dialog {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  /* 其他样式可以保持默认 */
}

.payment-original-price {
    margin-top: 20px;
    color: #687b79;
    font-size: 20px;
    line-height: 1.5;
}
.payment-original-price del {
    text-decoration-thickness: 1px;
}
</style>
